import React, { Suspense, lazy } from 'react'
import { Switch, useLocation } from 'react-router-dom'
import { Loading, ToastNotification } from 'ui'
import { useAuth, PageDataProvider, UserDataProvider, NotificationStatusProvider } from 'resources'
import {
  LOGOUT,
} from './routes'
import 'dayjs/locale/pt-br'
import dayjs from 'dayjs'

const Main = lazy(() => import('pages/main'))
const LiveNotification = lazy(() => import('pages/live-notification'))

dayjs.locale('pt-br')

const App = () => {
  const { pathname } = useLocation()
  const { didCheckUserIn, userInfo: { isUserLoggedIn }, logout } = useAuth()

  if (!didCheckUserIn) {
    return <Loading />
  }

  if (isUserLoggedIn && pathname === LOGOUT) {
    logout()
    return <Loading />
  }

  if (!isUserLoggedIn) {
    window.location.href = process.env.REACT_APP_BETA_VERSION_URL
    return <Loading />
  }

  return (
    <>
      <ToastNotification />
      <Suspense fallback={<Loading />}>
        <Switch>
          <PageDataProvider>
            <UserDataProvider>
              <NotificationStatusProvider>
                <LiveNotification />
                <Main />
              </NotificationStatusProvider>
            </UserDataProvider>
          </PageDataProvider>
        </Switch>
      </Suspense>
    </>
  )
}

export default App
